import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnvironmentActions } from '@app/core/actions';
import { CookiesConfiguration } from '@app/core/services/cookies.service';
import * as fromRoot from '@app/reducers/index';
import { hostnameIsFromMainDomain } from '@app/shared/helpers/location';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-smash-cookie-preference',
    templateUrl: './modal-cookie-preference.component.html',
    styleUrls: ['./modal-cookie-preference.component.scss']
})
export class ModalCookiePreferenceComponent implements OnInit, OnDestroy {

    @Output() closeModalEvent: EventEmitter<any> = new EventEmitter<any>();

    cookiesConsentConfiguration$: Observable<CookiesConfiguration>;

    cookiesConsentConfigurationForm: FormGroup;
    subscriptions: Subscription[] = [];
    allCookiesConsented = false;
    cookieAnalyticsConfigurable = false;

    isMobile: any;

    constructor(private readonly store: Store<fromRoot.State>, private deviceDetector: DeviceDetectorService, public ref: DialogRef) {
        this.cookiesConsentConfiguration$ = this.store.select(fromRoot.getCookiesConsentConfiguration);
        this.isMobile = this.deviceDetector.isMobile();
        this.cookieAnalyticsConfigurable = !hostnameIsFromMainDomain(location.hostname);
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm(): void {
        this.cookiesConsentConfigurationForm = new FormGroup({
            groups: new FormGroup({
                social: new FormGroup({
                    enabled: new FormControl(true, Validators.required),
                }),
                analytics: new FormGroup({
                    enabled: new FormControl(true, Validators.required),
                }),
            })
        });
        this.cookiesConsentConfiguration$.subscribe(value => {
            if (value?.groups?.social?.enabled && value?.groups?.analytics?.enabled) {
                this.allCookiesConsented = true;
            } else {
                this.allCookiesConsented = false;
            }
            this.cookiesConsentConfigurationForm.patchValue(value, { emitEvent: false });
        });
    }

    save() {
        if (this.cookiesConsentConfigurationForm.valid) {
            this.store.dispatch(EnvironmentActions.UpdateCookiesConsentConfiguration({ cookiesConsentConfiguration: this.cookiesConsentConfigurationForm.value }));
            this.close();
        }
    }

    close() {
        this.ref.close();
    }

    onToggleAllCategories(toggled) {
        this.cookiesConsentConfigurationForm.patchValue({
            groups: {
                marketing: { enabled: toggled },
                social: { enabled: toggled },
            }
        });
        if (this.cookieAnalyticsConfigurable) {
            this.cookiesConsentConfigurationForm.patchValue({
                groups: {
                    analytics: { enabled: toggled },
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
